import React from "react";
import "./Home.css";
import Product from "./Product";
import ReactNotification from "react-notifications-component";
import "react-notifications-component/dist/theme.css";

function Home() {
  return (
    <div className="home">
      <ReactNotification />
      <div className="home__container">
        <img
          className="home__poster"
          src="https://images-na.ssl-images-amazon.com/images/G/01/digital/video/merch/2019/Other/RB-1424_AcquisitionHolidayAssets/GW_DesktopHero_RB-1424_PV-AcquisitionHolidayAssets_1500x600._CB451871227_.jpg"
          alt="poster_image"
        />
        <div className="home__product">
          <Product
            className="product"
            productId="101"
            title="The Product Book"
            price={29.9}
            image="https://m.media-amazon.com/images/I/41sYkAlp2ML.jpg"
            rating={3}
          />
          <Product
            className="product"
            productId="102"
            title="The Product Ipod"
            price={400.8}
            image="https://images-na.ssl-images-amazon.com/images/I/71vGyoQGuzL._AC_SY355_.jpg"
            rating={4}
          />
          <Product
            className="product"
            productId="103"
            title="The Product laptop"
            price={1000.5}
            image="https://images-na.ssl-images-amazon.com/images/I/71Qb-9HVbQL._SX466_.jpg"
            rating={5}
          />
        </div>
        <div className="home__product">
          <Product
            className="product"
            productId="104"
            title="Fire TV Stick with Alexa Voice Remote"
            price={200.5}
            image="https://i.insider.com/5cbe1f80b14bf407f11cf82b?width=1100&format=jpeg&auto=webp"
            rating={4}
          />
          <Product
            className="product"
            productId="105"
            title="Amazon Echo"
            price={299.0}
            image="https://www.businessinsider.in/thumb/msid-69333786,width-640,resizemode-4,imgsize-835515/14-Amazon-Echo.jpg"
            rating={3}
          />
        </div>
        <div className="home__product">
          <Product
            className="product"
            productId="106"
            title="The Product Smart Watch"
            price={399.0}
            image="https://d3rlgjrg24xpvv.cloudfront.net/wp-content/uploads/2017/12/26095141/Amazon-A-Product-Image-Service-021.jpg"
            rating={2}
          />
        </div>
      </div>
    </div>
  );
}

export default Home;
